import { render, staticRenderFns } from "./DangerousInformersForm.vue?vue&type=template&id=4beebedd&scoped=true&"
import script from "./DangerousInformersForm.vue?vue&type=script&lang=js&"
export * from "./DangerousInformersForm.vue?vue&type=script&lang=js&"
import style0 from "./DangerousInformersForm.vue?vue&type=style&index=0&id=4beebedd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4beebedd",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VForm } from 'vuetify/lib/components/VForm';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VForm,VTextField})
